import XDialog from '@/components/dialog/index.vue'
import { addPortNode } from '../port'
import { h } from '@vue/composition-api'

export function showDialog(data: {
  title?: string
  message: string
  cancelText?: string
  confirmText: string
  style2?: boolean
  noCancel?: boolean
  onCancel?: () => any
  onConfirm?: () => any
}) {
  addPortNode(
    h({
      data: () => ({
        visible: false,
      }),

      mounted() {
        // @ts-ignore
        this.visible = true
      },

      render() {
        return h(XDialog, {
          props: {
            title: data.title,
            message: data.message,
            cancelText: data.cancelText || '取消',
            confirmText: data.confirmText,
            style2: data.style2 || false,
            value: this.visible,
            noCancel: data.noCancel,
          },
          on: {
            input: (visible: boolean) => {
              if (!visible) {
                // @ts-ignore
                this.visible = false
              }
            },
            cancel: data.onCancel,
            confirm: data.onConfirm,
          } as any,
        })
      },
    }),
  )
}
